module.exports = {"id":"139597","name":"Javi Guerra","rating":"72","photo":"./data/images/photos/0/139597.png","club":{"name":"Rayo Vallecano","logo":"./data/images/clubs/RayoVallecano.png"},"positions":["BU"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JaviGuerra0.json
// module id = 1937
// module chunks = 0